import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../../assets/svg/close-modal.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../../visitor/visitor-create/visitor-create.css";
import DOMPurify from 'dompurify';
import { createGateApi, getEmployeeListApi } from "../../modal-dialog/setup-api.js";
import { getGateDetailsApi, updateGateApi } from "./gatemasterlist-api.js";
import locationIcon from "../../../assets/svg/location-red.svg";
import userIconGreen from "../../../assets/svg/user-icon.svg";
import userIconBlue from "../../../assets/svg/user-icon-blue.svg";
import timeInfo from "../../../assets/svg/time-info.svg";
import { QRCodeSVG } from "qrcode.react";
import downloadimg from "../../../assets/svg/download-white.svg";
import printimg from "../../../assets/svg/print-green.svg";
import { ReactComponent as EditIcon} from "../../../assets/svg/edit.svg";
import { ReactComponent as DeleteIcon} from "../../../assets/svg/delete-icon.svg";
import { FaCheckCircle, } from "react-icons/fa";
 const GateViewModal = ({gateId, onEdit, onDelete, onCancel }) => {
  
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          
          borderRadius: "0px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "618px",
          height:"100vh",
          overflowY: "auto",
          padding:'16px'
        },
      };

  const [gateDetails, setGateDetails] = useState({});

    useEffect(() => { 
      if(gateId!=null){
        getGateDetails()
      }    
     },[]);   
   
  
            const getGateDetails = async () => {   
              try {
                const response = await getGateDetailsApi(gateId);
                if (response.status === true) {
                  setGateDetails(response.Gate_Master)
              }
                return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            };
    
      
    
             const printRef = useRef(null);
                       /*  const downloadQR = () => {
                          const svg = printRef.current.querySelector('svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

                          // const canvas = printRef.current.querySelector("canvas");
                          // const url = canvas.toDataURL("image/png");
                          const link = document.createElement("a");
                          link.href = url;
                          link.download = "qrcode.svg";
                          link.click();
                        }; */
                        const downloadQR = () => {
                          const svgElement = printRef.current.querySelector('svg');
                          const svgData = new XMLSerializer().serializeToString(svgElement);
                          const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
                          const DOMURL = window.URL || window.webkitURL || window;
                          const url = DOMURL.createObjectURL(svgBlob);
                      
                          const image = new Image();
                          image.onload = () => {
                            const canvas = document.createElement('canvas');
                            const size = 800; // 🟢 High resolution
                            canvas.width = size;
                            canvas.height = size;
                      
                            const ctx = canvas.getContext('2d');
                      
                            // Draw transparent background (optional, it's already transparent by default)
                            ctx.clearRect(0, 0, size, size);
                      
                            ctx.drawImage(image, 0, 0, size, size);
                      
                            // ✅ Convert to PNG and download
                            const pngUrl = canvas.toDataURL('image/png');
                            const downloadLink = document.createElement('a');
                            downloadLink.href = pngUrl;
                            downloadLink.download = `QR_${gateDetails.code}.png`;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            DOMURL.revokeObjectURL(url);
                          };
                      
                          image.src = url;
                        };
                        const handlePrint = () => {
                          console.log(printRef.current.innerHTM);
                          if (printRef.current) {
                          const printWindow = window.open('', '_blank');
                          printWindow.document.write(`
                            <html>
                              <head>
                                <title>Print QR Code</title>
                              </head>
                              <body style="display: flex; justify-content: center; align-items: center;">
                                ${printRef.current.innerHTML}
                              </body>
                            </html>
                          `);
                          printWindow.document.close();
                          printWindow.focus();
                          printWindow.print();
                          }
                        };
  const printRef2 = useRef(null);
                        const downloadGateOutQR = () => {
                          const canvas = printRef2.current.querySelector("canvas");
                          const url = canvas.toDataURL("image/png");
                          const link = document.createElement("a");
                          link.href = url;
                          link.download = "qrcode.png";
                          link.click();
                        };
                        const handlePrintGateOut = () => {
                          console.log(printRef2.current.innerHTM);
                          if (printRef2.current) {
                          const printWindow = window.open('', '_blank');
                          printWindow.document.write(`
                            <html>
                              <head>
                                <title>Print QR Code</title>
                              </head>
                              <body style="display: flex; justify-content: center; align-items: center;">
                                ${printRef2.current.innerHTML}
                              </body>
                            </html>
                          `);
                          printWindow.document.close();
                          printWindow.focus();
                          printWindow.print();
                          }
                        };
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div className="style-justify-between"
            >
              <div className="card-title"
    >
    {gateDetails.gatename??''}
    </div>
     <div className="style-justify-start ">
      
      <EditIcon onClick={onEdit} className="mx-3"/>
      <DeleteIcon onClick={onDelete} className="mx-2"/>
       <ModalCloseIcon
                style={{ cursor: "pointer" }}
                onClick={onCancel}
              />
              </div>
            </div>
            <div className="style-justify-start font-13-400-8790A1">
            Code : <span className="font-14-400-2C8C53  px-2">{gateDetails.code??''}</span>
            </div>
            <div className="font-16-600-172B4D mt-5">Other details</div>
            <div >
            <div className="style-justify-start mt-3">
              <div className="font-13-400-8790A1" style={{width:'180px'}}>Location</div>
              <div className="style-justify-start"><img src={locationIcon} alt="location"/> <span className="font-14-500-212129 px-2">{gateDetails.location??''}</span> </div>
              </div> 
          
              <div className="style-justify-start mt-3">
              <div className="font-13-400-8790A1" style={{width:'180px'}}>Responsible person</div>
              <div className="style-justify-start"><img src={userIconGreen} alt="responsible"/> <span className="font-14-500-212129 px-2">{gateDetails.responsible_person??''}</span> </div>
              </div>
              <div className="style-justify-start mt-3">
              <div className="font-13-400-8790A1" style={{width:'180px'}}>Shift</div>
              <div className="style-justify-start"> <span className="font-14-500-212129">{gateDetails.shift??''}</span> </div>
              </div> 
              <div className="style-justify-start mt-3">
              <div className="font-13-400-8790A1" style={{width:'180px'}}>Assigned To</div>
              <div className="style-justify-start"><img src={userIconBlue} alt="assign to"/> <span className="font-14-500-212129 px-2">{gateDetails.assignee?.map((item) => item.first_name).join(', ')}</span> </div>
              </div> 
                            
              <div className="style-justify-start mt-3">
              <div className="font-13-400-8790A1" style={{width:'180px'}}>Open & close time</div>
              <div className="style-justify-start"><img src={timeInfo} alt="time"/> <span className="font-14-500-212129 px-2">{gateDetails.opening_gate_time??''} - {gateDetails.closing_gate_time??''} </span> </div>
              </div>   
             
          <div className="style-justify-around mt-2">
           <div>
           <div className="font-16-600-172B4D mb-2" style={{textAlign:'center'}}>QR Code {gateDetails.scan_req_out===true?'(Gate In)':''}</div>  
              <div ref={printRef}  style={{textAlign: "center",}}>
              <QRCodeSVG
                value={gateDetails.link??''}
                size={180}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
               
              />
              </div>
                <div style={{marginTop:'20px', display: "flex", flexDirection:'column', alignItems:'center', justifyContent: "center", gap: "10px" }}>
                  <button
                  onClick={downloadQR}
                  className="gate-qr-dwnld-btn px-3"
                  >
                    <img src={downloadimg} alt="" /> Download
                  </button>
                  <button
                  onClick={handlePrint}
                    className="gate-qr-print-btn px-4"
                  >
                    <img src={printimg} alt="" /> Print
                  </button>
                </div> 
           </div>
              {gateDetails.scan_req_out===true &&(<div>
              <div className="font-16-600-172B4D mb-2" style={{textAlign:'center'}}>QR Code (Gate Out)</div>  
           <div className=" mt-2">
              <div ref={printRef2}  style={{textAlign: "center",}}>
              <QRCodeSVG
                value={gateDetails.out_link??''}
                size={180}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
               
              />
              </div>
                <div style={{marginTop:'20px', display: "flex", flexDirection:'column', alignItems:'center', justifyContent: "center", gap: "10px" }}>
                  <button
                  onClick={downloadGateOutQR}
                  className="gate-qr-dwnld-btn px-3"
                  >
                    <img src={downloadimg} alt="" /> Download
                  </button>
                  <button
                  onClick={handlePrintGateOut}
                    className="gate-qr-print-btn px-4"
                  >
                    <img src={printimg} alt="" /> Print
                  </button>
                </div> 
           </div>
              </div>)}
              </div>
              <div className="font-16-600-172B4D mt-5">Mandatory Fields</div>
              <div className="style-justify-start mt-3">
              <FaCheckCircle  style={{ color: gateDetails.proof_mandatory===true?'green':'grey' }} />
              <span className="font-14-500-212129 px-2">Proof</span>
              </div>
              <div className="style-justify-start mt-3">
              <FaCheckCircle  style={{ color: gateDetails.checklist_mandatory===true?'green':'grey' }} />
              <span className="font-14-500-212129 px-2">Check List</span>
              </div>
              <div className="style-justify-start mt-3">
              <FaCheckCircle  style={{ color: gateDetails.otp_mandatory===true?'green':'grey' }} />
              <span className="font-14-500-212129 px-2">OTP</span>
              </div>
              <div className="style-justify-start mt-3">
              <FaCheckCircle  style={{ color: gateDetails.diff_out_qr===true?'green':'grey' }} />
              <span className="font-14-500-212129 px-2">Separate QR for Gate out</span>
              </div>
              <div className="style-justify-start mt-3">
              <FaCheckCircle  style={{ color: gateDetails.scan_req_out===true?'green':'grey' }} />
              <span className="font-14-500-212129 px-2">Scan required for Gate out</span>
              </div>
              <div className="style-justify-start mt-3">
              <FaCheckCircle  style={{ color: gateDetails.expiry_date===true?'green':'grey' }} />
              <span className="font-14-500-212129 px-2">Expiry Date</span>
              </div>
            </div>
          </div>
        </div>
      </div>);

}

export default GateViewModal;